<template>
  <div>
    <div class="page-bar" style="margin-bottom:10px;">
      <ul class="page-breadcrumb">
          <li>
              <router-link :to="{name:'home'}">Accueil</router-link>
              <i class="fa fa-circle"></i>
          </li>
          <li>
              <router-link :to="{name:'users_list'}">Utilisateurs</router-link>
          </li>
          <li v-show="$route.params.id">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'users_edit',params:{id:$route.params.id}}">{{$route.params.id}}</router-link>
          </li>
          <li v-show="$route.name=='users_edit'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'users_edit'}">Edition</router-link>
          </li>
          <li v-show="$route.name=='users_create'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'users_create'}">Création</router-link>
          </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'users',
  data () {
    return{
    }
  },
  mounted:function(){
  },
  activated:function(){
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// users.vue?6569d41f